import { createContext, useContext } from 'react'

import { PermissionResolver } from '@/domain/permissions'

export const PermissionContext = createContext<{ permissionResolver: PermissionResolver } | null>(null)

export const usePermissionContext = () => {
    const context = useContext(PermissionContext)

    if (!context) {
        throw new Error('`usePermissionContext` must be used within a `PermissionContext.Provider`')
    }

    return context.permissionResolver
}
